module.exports = {
  billing_reconciliation: 'การกระทบยอด',
  billing_bill: 'ใบแจ้งหนี้',
  billing_accountStatement: 'ใบกระทบยอด',
  billing_cancel: 'ยกเลิก',
  billing_return: 'กลับ',
  billing_save: 'บันทึก',
  billing_edit: 'แก้ไข',
  billing_collectInvoice: 'รับใบเสร็จ',
  billing_drawInvoice: 'ออกใบเสร็จ',
  billing_writeOff: 'ตัดหนี้',
  billing_applyForPayment: 'ขอชำระเงิน',
  billing_paymentBillState: 'สถานะใบชำระเงิน',
  billing_print: 'พิมพ์',
  billing_adjustBillDate: 'ปรับวันที่ใบแจ้งหนี้',
  billing_addCharges: 'เพิ่มค่าใช้จ่าย',
  billing_deleteCharges: 'ลบค่าใช้จ่าย',
  billing_deleteAll: 'ลบทั้งหมด',
  billing_viewDeleteChargeDetail: 'ดู/ลบรายละเอียด',
  billing_newAdjustment: 'เพิ่มการปรับ',
  billing_editAdjustment: 'แก้ไขการปรับ',
  billing_deleteAdjustment: 'ลบการปรับ',
  billing_diffCharge: 'จัดการส่วนต่าง',
  billing_cancelConfirm: 'ยกเลิกการยืนยัน',
  billing_batchConfirm: 'ยืนยันเป็นกลุ่ม',
  billing_reconciliationAmount: 'จำนวนเงินกระทบยอด',
  billing_exchangeRate: 'อัตราแลกเปลี่ยน',
  billing_charges: 'ค่าใช้จ่าย',
  billing_business: 'ธุรกิจ',
  billing_recheck: 'ทวนสอบ',
  billing_cancelRecheck: 'ยกเลิกการทวนสอบ',
  includeAdjustmentCharge: 'รวมค่าใช้จ่ายการปรับแต่งหรือไม่',
  billing_recheckTip: 'กรุณายืนยันใบแจ้งหนี้ก่อนทวนสอบ',
  billing_recheckStatus: 'สถานะการทวนสอบใบแจ้งหนี้',
  billing_reviewPeople: 'ผู้ทวนสอบใบแจ้งหนี้',
  billing_reviewDate: 'เวลาทวนสอบใบแจ้งหนี้',
  billingView_Determine: 'ตกลง',
  billingView_Close: 'ปิด',
  chargeList_query: 'ค้นหา',
  chargeList_newBill: 'สร้างใบแจ้งหนี้ใหม่',
  chargeList_startReconciliation: 'เริ่มกระทบยอด',
  chargeList_drawCollectInvoice: 'ออกใบเสร็จ/รับใบเสร็จ',
  chargeList_writeOff: 'ตัดหนี้',
  chargeList_applyForPayment: 'ขอชำระเงิน',
  chargeList_submission: 'ส่ง',
  chargeList_cancelSubmit: 'ยกเลิกการส่ง',
  chargeList_revenueAndExpenditureMethod: 'วิธีการรับ/จ่าย',
  chargeList_invoiceRevenueAndExpenditureMethod: 'ประเภทการรับ/จ่ายใบเสร็จ',
  chargeList_receivables: 'รับได้',
  chargeList_payables: 'จ่ายได้',
  chargeList_all: 'ทั้งหมด',
  chargeList_feeType: 'ประเภทค่าใช้จ่าย',
  chargeList_domestic: 'ในประเทศ',
  chargeList_international: 'ต่างประเทศ',
  chargeList_reconciliationType: 'ประเภทการตรวจสอบยอด',
  chargeList_accordingToCharges: 'ตามค่าใช้จ่าย',
  chargeList_accordingToBusiness: 'ตามธุรกิจ',
  chargeList_cancelReconciliation: 'ยกเลิกการตรวจสอบยอด',
  chargeList_saveReconciliation: 'บันทึกการตรวจสอบยอด',
  chargeList_newAdjustment: 'เพิ่มการปรับ',
  chargeList_editAdjustment: 'แก้ไขการปรับ',
  chargeList_deleteAdjustment: 'ลบการปรับ',
  chargeList_diffCharge: 'จัดการส่วนต่าง',
  chargeList_cancelConfirm: 'ยกเลิกการยืนยัน',
  chargeList_batchConfirm: 'ยืนยันเป็นกลุ่ม',
  billingCharge_businessNumber: 'เลขที่ธุรกิจ',
  billingCharge_consignationCompany: 'หน่วยงานผู้ว่าจ้าง',
  billingCharge_settlementCompany: 'หน่วยงานชำระเงิน',
  billingCharge_mblNo: 'เลขที่เอกสารหลัก',
  billingCharge_vessel: 'ชื่อเรือ',
  billingCharge_voyage: 'เที่ยวบิน/เที่ยวเรือ',
  billingCharge_carrier: 'ผู้ขนส่ง',
  billingCharge_billNo: 'เลขที่บิล',
  billingCharge_invoiceNo: 'เลขที่ใบแจ้งหนี้',
  billingCharge_itemNo: 'เลขที่โครงการ',
  billingCharge_businessType: 'ประเภทธุรกิจ',
  billingCharge_businessStatus: 'สถานะธุรกิจ',
  billingCharge_solicitationType: 'ประเภทการรับสินค้า',
  billingCharge_chargeItem: 'ชื่อค่าใช้จ่าย',
  billingCharge_feeStatus: 'สถานะค่าใช้จ่าย',
  billingCharge_confirmStatus: 'สถานะการยืนยัน',
  billingCharge_businessDate: 'วันที่ธุรกิจ',
  billingCharge_amountRange: 'ช่วงจำนวนเงิน',
  billingCharge_receivablesInvoicingDate: 'วันที่ออกใบแจ้งหนี้รับ',
  billingCharge_currency: 'สกุลเงิน',
  billingCharge_operation: 'ดำเนินการ',
  billingCharge_sales: 'ขาย',
  billingCharge_advanceMoneyForAnotherOrNot: 'มีการจ่ายแทนหรือไม่',
  billingCharge_adjustedOrNot: 'มีการปรับหรือไม่',
  billingCharge_wroteOffOrNot: 'มีการตัดจ่ายหรือไม่',
  billingCharge_generatedBillsOrNot: 'มีการสร้างบิลหรือไม่',
  billingCharge_invoicedOrNot: 'มีการออกใบแจ้งหนี้หรือไม่',
  billingCharge_appliedForPaymentOrNot: 'มีการขอชำระเงินหรือไม่',
  billingCharge_drawABbillOrNot: 'จำเป็นต้องออกใบแจ้งหนี้หรือไม่',
  billingCharge_department: 'แผนก',
  billingCharge_contactPerson: 'ผู้ติดต่อ',
  billingCharge_settlementType: 'ประเภทการชำระเงิน',
  billingCharge_invoicingMethod: 'วิธีการออกใบแจ้งหนี้',
  billingCharge_accrued: 'ได้มีการตั้งไว้แล้ว',
  billingCharge_receivablesInvoicingStatus: 'สถานะใบแจ้งหนี้รับ',
  billingCharge_bookingNo: 'เลขที่การจอง',
  billingCharge_unitPrice: 'ราคาต่อหน่วย',
  billingCharge_invoiceHeader: 'ชื่อใบแจ้งหนี้',
  billingCharge_businessReferenceNumber: 'เลขที่อ้างอิงธุรกิจ',
  billingCharge_warehouseNo: 'หมายเลขรับเข้าคลัง',
  billingCharge_vesselAndVoyage: 'ชื่อเรือและเที่ยวบิน',
  billingCharge_portOfLoading: 'ท่าเรือต้นทาง',
  billingCharge_portOfTransfer: 'ท่าเรือขนถ่าย',
  billingCharge_portOfDestination: 'ท่าเรือปลายทาง',
  billingCharge_portOfLoadingSeaport: 'ท่าเรือต้นทาง(ทางทะเล)',
  billingCharge_portOfLoadingAirport: 'ท่าเรือต้นทาง(ทางอากาศ)',
  billingCharge_portOfDestinationSeaport: 'ท่าเรือปลายทาง(ทางทะเล)',
  billingCharge_portOfDestinationAirport: 'ท่าเรือปลายทาง(ทางอากาศ)',
  billingCharge_portOfDischargeSeaport: 'ท่าเรือขนถ่ายสินค้า(ทางทะเล)',
  billingCharge_portOfDischargeAirport: 'ท่าเรือขนถ่ายสินค้า(ทางอากาศ)',
  billingCharge_financialDate: 'วันที่ทางการเงิน',
  billingCharge_domesticOrInternational: 'ภายในประเทศ/ต่างประเทศ',
  billingCharge_paymentType: 'ประเภทการชำระเงิน',
  billingCharge_amount: 'จำนวน',
  billingCharge_taxIncludedPrice: 'ราคารวมภาษี',
  billingCharge_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  billingCharge_taxAmount: 'จำนวนภาษี',
  billingCharge_theAmountOfWriteOffs: 'จำนวนเงินที่ตรวจสอบแล้ว',
  billingCharge_amountNotWrittenOff: 'จำนวนเงินที่ยังไม่ตรวจสอบ',
  billingCharge_reconciliationAmount: 'จำนวนเงินในการตรวจสอบ',
  billingCharge_difference: 'ส่วนต่าง',
  billingCharge_confirmationRemarks: 'หมายเหตุการยืนยัน',
  billingCharge_confirmState: 'ยืนยันหรือไม่',
  billingCharge_creator: 'ผู้สร้าง',
  billingCharge_dateCreated: 'วันที่สร้าง',
  billingCharge_remarks: 'หมายเหตุ',
  billingJob_businessNumber: 'เลขที่ธุรกิจ',
  billingJob_consignationCompany: 'หน่วยงานที่มอบหมาย',
  billingJob_settlementCompany: 'หน่วยงานชำระเงิน',
  billingJob_mblNo: 'เลขที่เอกสารหลัก',
  billingJob_vessel: 'ชื่อเรือ',
  billingJob_voyage: 'เที่ยวบิน',
  billingJob_carrier: 'ผู้ขนส่ง',
  billingJob_billNo: 'เลขที่บิล',
  billingJob_invoiceNo: 'เลขที่ใบแจ้งหนี้',
  billingJob_itemNo: 'เลขที่โครงการ',
  billingJob_businessType: 'ประเภทธุรกิจ',
  billingJob_soNo: 'เลขที่ SO',
  billingJob_businessStatus: 'สถานะธุรกิจ',
  billingJob_solicitationType: 'ประเภทการรับสินค้า',
  billingJob_chargeItem: 'ชื่อค่าใช้จ่าย',
  billingJob_feeStatus: 'สถานะค่าใช้จ่าย',
  billingJob_confirmStatus: 'สถานะการยืนยัน',
  billingJob_businessDate: 'วันที่ทำธุรกิจ',
  billingJob_amountRange: 'ช่วงจำนวนเงิน',
  billingJob_receivablesInvoicingDate: 'วันที่ควรออกใบแจ้งหนี้',
  billingJob_currency: 'สกุลเงิน',
  billingJob_operation: 'ดำเนินการ',
  billingJob_sales: 'การขาย',
  billingJob_advanceMoneyForAnotherOrNot: 'มีการจ่ายแทนหรือไม่',
  billingJob_adjustedOrNot: 'มีการปรับหรือไม่',
  billingJob_wroteOffOrNot: 'มีการตัดจ่ายแล้วหรือไม่',
  billingJob_generatedBillsOrNot: 'มีการสร้างใบแจ้งหนี้แล้วหรือไม่',
  billingJob_invoicedOrNot: 'มีการออกใบกำกับภาษีแล้วหรือไม่',
  billingJob_appliedForPaymentOrNot: 'มีการขอชำระเงินแล้วหรือไม่',
  billingJob_drawABbillOrNot: 'จำเป็นต้องออกใบกำกับภาษีหรือไม่',
  billingJob_department: 'แผนก',
  billingJob_contactPerson: 'ผู้ติดต่อ',
  billingJob_settlementType: 'ประเภทการชำระเงิน',
  billingJob_invoicingMethod: 'วิธีการออกใบกำกับภาษี',
  billingJob_accrued: 'ได้มีการบันทึกแล้ว',
  billingJob_receivablesInvoicingStatus: 'สถานะใบกำกับภาษีที่ต้องรับ',
  billingJob_bookingNo: 'หมายเลขการจองพื้นที่',
  billingJob_unitPrice: 'ราคาต่อหน่วย',
  billingJob_invoiceHeader: 'ชื่อในใบกำกับภาษี',
  billingJob_businessReferenceNumber: 'หมายเลขอ้างอิงธุรกิจ',
  billingJob_warehouseNo: 'หมายเลขการรับเข้าคลัง',
  billingJob_vesselAndVoyage: 'ชื่อเรือและเที่ยวบิน',
  billingJob_portOfLoading: 'ท่าเรือต้นทาง',
  billingJob_portOfTransfer: 'ท่าเรือกลางทาง',
  billingJob_portOfDestination: 'ท่าเรือปลายทาง',
  billingJob_portOfLoadingSeaport: 'ท่าเรือต้นทาง(ทางทะเล)',
  billingJob_portOfLoadingAirport: 'ท่าเรือต้นทาง(ทางอากาศ)',
  billingJob_portOfDestinationSeaport: 'ท่าเรือปลายทาง(ทางทะเล)',
  billingJob_portOfDestinationAirport: 'ท่าเรือปลายทาง(ทางอากาศ)',
  billingJob_portOfDischargeSeaport: 'ท่าเรือขนถ่าย(ทางทะเล)',
  billingJob_portOfDischargeAirport: 'ท่าเรือขนถ่าย(ทางอากาศ)',
  billingJob_financialDate: 'วันที่ทางการเงิน',
  billingJob_domesticOrInternational: 'ในประเทศ/ต่างประเทศ',
  billingJob_paymentType: 'ประเภทการชำระเงิน',
  billingJob_amount: 'จำนวน',
  billingJob_taxIncludedPrice: 'ราคารวมภาษี',
  billingJob_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  billingJob_taxAmount: 'จำนวนภาษี',
  billingJob_theAmountOfWriteOffs: 'จำนวนเงินที่ตัดจ่าย',
  billingJob_amountNotWrittenOff: 'จำนวนเงินที่ยังไม่ตัดจ่าย',
  billingJob_reconciliationAmount: 'จำนวนเงินในการตรวจสอบ',
  billingJob_difference: 'ส่วนต่าง',
  billingJob_confirmationRemarks: 'หมายเหตุการยืนยัน',
  billingJob_ReviewRemarks: 'หมายเหตุการตรวจสอบ',
  InquiryLetterRemark: 'หมายเหตุ หนังสือสอบถาม',
  WarmPromptAppend: 'เคล็ดลับที่อบอุ่น: หมายเหตุที่กรอกจะถูกเพิ่มเข้าไปในข้อความหมายเหตุทางการเงินเดิม',
  WarmPromptOverwrite: 'เคล็ดลับที่อบอุ่น: หมายเหตุที่กรอกจะเขียนทับหลังจดหมายสอบถามต้นฉบับหมายเหตุ',
  billingJob_confirmState: 'มีการยืนยันหรือไม่',
  billingJob_creator: 'ผู้สร้าง',
  billingJob_dateCreated: 'วันที่สร้าง',
  billingJob_remarks: 'หมายเหตุ',
  billingJob_customerLevel: 'ระดับลูกค้า',
  billingJob_settlementMethod: 'วิธีการชำระเงิน',
  billingJob_chargesContactPerson: 'ผู้ติดต่อด้านค่าใช้จ่าย',
  billingJob_confirmUser: 'ผู้ยืนยันค่าใช้จ่าย',
  billingJob_updateUser: 'ผู้ปรับปรุงค่าใช้จ่าย',
  billingJob_settleAccountsTo: 'วัตถุการชำระเงิน',
  billingJob_otherPartyBilling: 'เลขที่ใบแจ้งหนี้ของคู่กรณี',
  billingJob_customer: 'ลูกค้า',
  billingJob_portOfDischarge: 'ท่าขนถ่ายสินค้า',
  billingJob_dateOfDeparture: 'วันที่ออกเรือ',
  billingJob_bookingAgent: 'ตัวแทนจองพื้นที่เรือ',
  billingJob_revenueAndExpenditureType: 'ประเภทรายรับรายจ่าย',
  billingJob_chargesTotalAmount: 'ยอดรวมค่าใช้จ่าย',
  billingJob_dateOfArrival: 'วันที่ถึงท่าเรือ',
  billingJob_billDate: 'วันที่ใบแจ้งหนี้',
  billingJob_invoiceDate: 'วันที่ออกใบกำกับ',
  billingJob_originalCurrency: 'สกุลเงินเดิม',
  billingJob_billAndCurrency: 'สกุลเงินใบแจ้งหนี้',
  billing_billAmount: 'จำนวนเงินใบแจ้งหนี้',
  billingJob_operationDepartment: 'แผนกปฏิบัติการ',
  billingJob_generatedAccountStatement: 'สร้างใบแจ้งหนี้แล้วหรือไม่',
  billingJob_wroteOff: 'มีการตัดจ่ายหรือไม่',
  billingJob_aging: 'อายุหนี้ (วัน)',
  billingJob_agentBillNo: 'เลขที่ใบแจ้งหนี้ของคู่กรณี',
  billingJob_billStatus: 'สถานะใบแจ้งหนี้',
  billingJob_accountStatementNo: 'เลขที่ใบแจ้งหนี้',
  billingJob_invoicingRequirements: 'ข้อกำหนดการออกใบกำกับ',
  billingJob_proofDate: 'วันที่เอกสารหลักฐาน',
  billingJob_customerService: 'บริการลูกค้า',
  billingJob_invoicingStatus: 'สถานะการออกใบกำกับ',
  billingJob_writeOffStatus: 'สถานะการตัดจ่าย',
  billingJob_writeOffStatus_bill: 'สถานะการตัดจ่ายใบแจ้งหนี้',
  billingJob_writeOffStatus_reconciliation: 'สถานะการตัดจ่ายใบแจ้งหนี้',
  billingJob_amountOfMoney: 'จำนวนเงิน',
  billingJob_notInvoicedMoney: 'ยอดเงินที่ยังไม่ออกใบกำกับ',
  billingJob_totalCurrency: 'รวมแยกตามสกุลเงิน',
  billingJob_totalAmountNotWrittenOff: 'ยอดรวมที่ยังไม่ตัดจ่าย',
  billingJob_taxRate: 'อัตราภาษี (%)',
  billingJob_customJobType: 'ประเภทงานที่กำหนดเอง',
  billingJob_voyageLine: 'เส้นทางเดินเรือ',
  billingJob_separateNumber: 'เลขที่ใบแจ้งหนี้ย่อย',
  billingJob_dateTo: 'ถึง',
  billingJob_lockCheckBoxDate: 'ค้นหาข้อมูลเกิน 2 ปี',
  billingJob_inputDateNotEmpty: 'วันที่ใบแจ้งหนี้ห้ามว่าง!',
  billingJob_unlockInputDateQuery: 'หากเลือกช่วงวันที่ใบแจ้งหนี้เกิน 2 ปี จะทำให้การโหลดข้อมูลช้าลง ยืนยันที่จะค้นหาข้อมูลเกิน 2 ปีหรือไม่?',
  billingJob_billPaymentDate: 'วันที่ขอ',
  billingJob_billPaymentDateNotEmpty: 'วันที่ขอห้ามว่าง!',
  billingJob_unlockBillPaymentDateQuery: 'หากเลือกช่วงวันที่ขอเกิน 2 ปี จะทำให้การโหลดข้อมูลช้าลง ยืนยันที่จะค้นหาข้อมูลเกิน 2 ปีหรือไม่?',
  billingJob_userDefinedField1: 'ฟิลด์ที่กำหนดเอง 1',
  billingJob_userDefinedField2: 'ฟิลด์ที่กำหนดเอง 2',
  billingJob_userDefinedField3: 'ฟิลด์ที่กำหนดเอง 3',
  billingJob_userDefinedField4: 'ฟิลด์ที่กำหนดเอง 4',
  billingJob_markDate: 'เวลาทำเครื่องหมาย',
  billingJob_markUser: 'ผู้ทำเครื่องหมาย',
  billingJob_markStatus: 'สถานะการทำเครื่องหมาย',
  billingJob_mark: 'ทำเครื่องหมายหรือไม่',
  billingJob_vesselAndVoyageAndFlight: 'ชื่อเรือ/เที่ยวบิน',
  billingJob_billPaymentOrNot: 'ขอชำระเงินหรือไม่',
  billingJob_voyageAndFlight: 'เที่ยวบิน/เที่ยวเรือ',
  billingJob_containerDescription: 'คำอธิบายปริมาณตู้',
  billingJob_InputDate: 'วันที่ออกใบแจ้งยอด',

  billingView_total: 'รวม',
  billingView_query: 'ค้นหา',
  billingView_newAccountStatement: 'สร้างใบแจ้งหนี้ใหม่',
  billingView_edit: 'แก้ไข',
  billingView_delete: 'ลบ',
  billingView_view: 'ดู',
  billingView_confirm: 'ยืนยัน',
  billingView_cancelConfirmation: 'ยกเลิกการยืนยัน',
  billingView_print: 'พิมพ์',
  billingView_drawCollectInvoice: 'ออกใบแจ้งหนี้/รับใบแจ้งหนี้',
  billingView_writeOff: 'ตัดจ่าย',
  billingView_applyForPayment: 'ขอชำระเงิน',
  billingView_revenueAndExpenditureMethod: 'วิธีการรับจ่าย',
  billingView_receivables: 'ต้องรับ',
  billingView_payables: 'ต้องจ่าย',
  billingView_all: 'ทั้งหมด',
  billingView_billType: 'ประเภทใบแจ้งหนี้',
  billingView_domestic: 'ในประเทศ',
  billingView_international: 'ต่างประเทศ',
  billingView_reconciliationType: 'ประเภทการตรวจสอบ',
  billingView_accordingToBusiness: 'ตามธุรกิจ',
  billingView_accordingToCharges: 'ตามค่าใช้จ่าย',
  billingForm_taxAmount: 'จำนวนเงินรวมภาษี',
  billingForm_taxFreeAmount: 'จำนวนเงินไม่รวมภาษี',
  billingForm_bankOfDeposit: 'ธนาคารที่เปิดบัญชี',
  billingForm_bankAccount: 'เลขที่บัญชีธนาคาร',
  billingForm_collectAndPrepaidOrNot: 'มีการเรียกเก็บหรือจ่ายแทนหรือไม่',
  billingForm_unit: 'หน่วยงาน',
  billingAccount_accountStatementType: 'ประเภทใบแจ้งหนี้',
  billingAccount_writeOffOrNot: 'มีการตัดจ่ายแล้วหรือไม่',
  billingAccount_invoicingInformation: 'ข้อมูลการออกใบแจ้งหนี้',
  billingGroup_dateOfFiling: 'วันที่ทำเอกสาร',
  billingGroup_settleAccountsTo: 'วัตถุการชำระเงิน',
  billingGroup_invoicingAddress: 'ที่อยู่ในการออกใบแจ้งหนี้',
  billingGroup_addBill: ' 加入账单',
  billingGroup_deleteBill: 'นำออกจากใบแจ้งหนี้',
  billingGroup_previous: 'ก่อนหน้า',
  billingGroup_next: 'ถัดไป',
  billingJob_settlementAgent: 'ตัวแทนชำระเงิน',
  billingJob_billingCreator: 'ผู้สร้างใบแจ้งหนี้',
  Query: 'ค้นหา',
  View: 'ดู',
  Add: 'เพิ่มใหม่',
  Edit: 'แก้ไข',
  Delete: 'ลบ',
  print: 'พิมพ์',
  statistics: 'สถิติ',
  ExportAllExcel: 'ส่งออกทั้งหมดเป็น Excel',
  BusinessNo: 'เลขที่ธุรกิจ',
  WarehouseNo: 'เลขที่รับเข้าคลัง',
  WayBillNumber: 'เลขที่ใบส่งของ',
  Destination: 'สถานีปลายทาง',
  PortOfDestination: 'ท่าเรือปลายทาง',
  WarehouseEntryTime: 'เวลารับเข้าคลัง',
  DeliveryTime: 'เวลาส่งออกจากคลัง',
  InputTime: 'เวลาบันทึกข้อมูล',
  DataEntryClerk: 'ผู้บันทึกข้อมูล',
  NumberOfCases: 'จำนวนชิ้น',
  Weight: 'น้ำหนัก',
  Volume: 'ปริมาตร',
  ComputationIsAffectedByDampness: 'ชำรุด/เปียกชื้น',
  IntoTheWarehousePhotos: 'รูปภาพรับเข้าคลัง',
  WarehouseName: 'ชื่อคลังสินค้า',
  Warehouseman: 'พนักงานคลังสินค้า',
  StorageLocation: 'ตำแหน่งในคลัง',
  Receiptnumber: 'เลขที่ใบรับ',
  BlNo: 'เลขที่ใบตราส่ง',
  UploadFile: 'อัปโหลดไฟล์',
  batchdownload: 'ดาวน์โหลดเป็นชุด',
  ResetFilter: 'รีเซ็ตเงื่อนไข',
  billingCharge_billingGroupNo: 'เลขที่ใบแจ้งยอด',
  modifiedBy: 'ผู้แก้ไข',
  dateModified: 'วันที่แก้ไข',
  invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  revenueOrExpenditure: 'รายรับรายจ่าย',
  InvoicingAmount: 'จำนวนเงินในใบแจ้งหนี้',
  invoicingExchangeRate: 'อัตราแลกเปลี่ยนในใบแจ้งหนี้',
  invoiceInformation: 'ข้อมูลใบแจ้งหนี้',
  LoadingPort: 'ท่าเรือบรรทุก',
  seaportOfDischarge: 'ท่าเรือขนถ่าย (ท่าเรือทะเล)',
  billingJob_confirmDate: 'เวลายืนยันใบแจ้งยอด',
  billingJob_theAmountOfNotWriteOffs: 'จำนวนเงินที่ยังไม่ได้ตรวจสอบ',
  QueryAgencyShareBill: 'ค้นหาใบแจ้งยอดค่าคอมมิชชั่นตัวแทน',
  ForceDeleteBilling: 'ไม่สามารถลบใบแจ้งยอด {0}{1} แบบบังคับได้',
  HasBillPayment: 'คำขอชำระเงินแล้ว',
  HasBillingGroup: 'สร้างใบแจ้งยอดแล้ว',
  HasWriteOff: 'ตรวจสอบแล้ว',
  HasClosingAccount: 'ปิดบัญชีแล้ว',
  OppositeBillNoAlreadyExists: '<strong>เลขที่ใบแจ้งยอดของอีกฝ่าย</strong> มีอยู่แล้ว ต้องการดำเนินการต่อหรือไม่?',
  DueDate: 'วันครบกำหนดชำระ',
  DueDateDirty: 'สถานะการคำนวณวันครบกำหนด',
  InCalculation: 'กำลังคำนวณ',
  NotCalculated: 'ไม่คำนวณ',
  Calculated: 'คำนวณแล้ว',
  CancelConfirmedBillSameTime: 'ต้องการยกเลิกการยืนยันบิลพร้อมกันหรือไม่?',
  BillingConfirmStatus: 'สถานะการยืนยันบิล',
  ApplyForInvoicing: 'ขอออกใบแจ้งหนี้',
  BillSettlementType: 'ประเภทการชำระบิล',
  CostCannotExceed3Currencies: 'ค่าใช้จ่ายไม่สามารถเกิน 3 สกุลเงิน',
  DomesticBill: 'บิลภายในประเทศ',
  Currency: 'สกุลเงิน',
  CannotRemoveAllFees: 'ไม่สามารถลบค่าใช้จ่ายทั้งหมดได้!',
  InvalidDate: 'วันที่ยกเลิก',
  Bill: 'บิล:',
  Billing_Requirements: 'ข้อกำหนดการออกใบแจ้งหนี้',
  ForeignInvoiceTime: 'เวลาออกใบแจ้งหนี้ต่างประเทศ'
}
